export const NAVBAR_HEIGHT_IN_PX = 64;
